import { ObjectFromList, subjectList } from "shared/models/defineAbility";

export interface IPagination {
  total: number;
  pages: number;
  perPage: number;
  curPage: number;
}

export interface IListPagination<T> {
  data: T[];
  pagination: IPagination;
}

export type ISubjectParamsObject = {
  url: string;
  title: string;
};

export type ISubjectParams = ObjectFromList<
  typeof subjectList,
  ISubjectParamsObject
>;

export const SubjectParams: ISubjectParams = {
  Address: {
    url: "/address",
    title: "Objects",
  },
  Car: {
    url: "/car",
    title: "Cars",
  },
  Calibration: {
    url: "/calibration",
    title: "Calibrations",
  },
  Category: {
    url: "/category",
    title: "Categories",
  },
  City: {
    url: "/city",
    title: "Cities",
  },
  Country: {
    url: "/country",
    title: "Countries",
  },
  Event: {
    url: "/event",
    title: "Events",
  },
  Investor: {
    url: "/investor",
    title: "Investors",
  },
  InvestObject: {
    url: "/invest-object",
    title: "Invest Objects",
  },
  InvestGroup: {
    url: "/invest-group",
    title: "Invest Group",
  },
  Location: {
    url: "/location",
    title: "Locations",
  },
  Machine: {
    url: "/machine",
    title: "Machines",
  },
  Object: {
    url: "/address",
    title: "Objects",
  },
  Order: {
    url: "/order",
    title: "Orders",
  },
  Payment: {
    url: "/payment",
    title: "Payments",
  },
  Payout: {
    url: "/payout",
    title: "Payouts",
  },
  Permission: {
    url: "/permission",
    title: "Permissions",
  },
  Product: {
    url: "/product",
    title: "Products",
  },
  Provider: {
    url: "/provider",
    title: "Providers",
  },
  Role: {
    url: "/role",
    title: "Roles",
  },
  Route: {
    url: "/route",
    title: "Routes",
  },
  Service: {
    url: "/service",
    title: "Service",
  },
  SnackAddress: {
    url: "/snack",
    title: "Snack Object",
  },
  SnackItem: {
    url: "/snack-item",
    title: "Snack Item",
  },

  Space: {
    url: "/space",
    title: "Spaces",
  },
  Store: {
    url: "/store-document",
    title: "Documents",
  },
  Task: {
    url: "/task",
    title: "Tasks",
  },
  Template: {
    url: "/template",
    title: "New installations",
  },
  User: {
    url: "/user",
    title: "Users",
  },
  Visit: {
    url: "/visit",
    title: "Visits",
  },
  all: {
    url: "/",
    title: "Home",
  },
};
